import { render, staticRenderFns } from "./redadd.vue?vue&type=template&id=23fc29b7&scoped=true"
import script from "./redadd.vue?vue&type=script&lang=js"
export * from "./redadd.vue?vue&type=script&lang=js"
import style0 from "./redadd.vue?vue&type=style&index=0&id=23fc29b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fc29b7",
  null
  
)

export default component.exports